import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 500px;
  align-self: center;
  margin-top: ${({ theme }) => theme.spacings[4]};
`;
